import firebase from 'firebase/app'
import "firebase/auth";
import firebaseConfigs from '@/pages/js/firebaseConfigs.js'

async function checkFirebaseTokenVerify(id, token) {
  const config = process.env.BASE_API === 'https://ccbot.a-p-i.io/public' ? firebaseConfigs.prod : firebaseConfigs.dev
  if (id && config[id]) {
   
    
    const firebaseConfig = config[id]
    const headers = {
      'Content-Type': 'application/json'
    };
    const url = 'https://identitytoolkit.googleapis.com/v1/accounts:lookup?key=' + firebaseConfig.apiKey;
    const data = {
      idToken : token
    }
    try {
      const response =  await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data)
      })
      const res = await response.json()
      if (res.error) {
        return false
      } else {
        return true
      }
    } catch (error) {
      return false
    }
  } else {
    throw TypeError("No User ID")
  }
}

async function checkFirebase(id,token) {
  const config = process.env.BASE_API === 'https://ccbot.a-p-i.io/public' ? firebaseConfigs.prod : firebaseConfigs.dev
  if (id && config[id]) {
    const firebaseConfig = config[id]
    try {
      // const app = await firebase.initializeApp(firebaseConfig)
      const app = !firebase.apps.length ? await firebase.initializeApp(firebaseConfig) : firebase.app()
      app.auth().onAuthStateChanged((user) => {
      })
      const idToken = await firebaseSignAnony(app, token)   
      return idToken
    } catch (error) {
     
      throw TypeError(error)
    }
  } else {
    throw TypeError("No User ID")
  }
}

async function firebaseSignAnony (app, token) {
  let idToken 
  try {
    if (token){
      const {user} =  await app.auth().signInWithCustomToken(token)
      idToken =  await checkUser(user)

    } else {
      const {user} =  await app.auth().signInAnonymously()
      idToken =  await checkUser(user)
    }
    return  idToken
  } catch (error) {
    return error
  }
}

async function checkUser(user) {
    try {
      sessionStorage.setItem('uid', user.uid)
      return await user.getIdToken(true)
      // return idToken
    } catch (error) {
      return error.toString()
    }
}

export  { checkFirebase, checkFirebaseTokenVerify }


// WEBPACK FOOTER //
// ./src/pages/js/firebaseHelper.js